<script>
export default {
    props: {
        loadTime: Number
    },
    methods: {
        pageLoadClass() {
            let pageLoadClass = 'text-green-600'
            let loadTime = this.$page.props.loadTime * 1

            if (loadTime < 1.5) {
                pageLoadClass = 'text-green-600'
            } else if (loadTime > 5) {
                pageLoadClass = 'text-red-600'
            } else {
                pageLoadClass = 'text-yellow-500'
            }

            return pageLoadClass
        },
        pageLoadMessage() {
            return this.__('Page generated in') + ' ' + this.$page.props.loadTime + ' ' + this.__('seconds')
        }
    }
}
</script>

<template>
    <footer id="main_footer">
        <div class="copyright">
            {{ __('Copyright') }} &copy; 2004 - {{ new Date().getFullYear() }} Spotler CRM. {{ __('All rights reserved')
            }}.
            <span
                :class="pageLoadClass()"
                :title="pageLoadMessage()"
            ><i class="fas fa-tachometer-alt" /></span>
        </div>
    </footer>
</template>
